import Signature from "./Signature";

const Story = () => (
  <section id="story" className="bg-background py-20 sm:py-28">
    <div className="reading-column px-6">
      <h2 className="font-serif text-3xl text-foreground sm:text-4xl">
        My story
      </h2>

      <div className="mt-8 space-y-6 text-lg text-foreground/85">
        <p>
          For years, I told myself I'd sort it out next month. Next Monday. After the holidays.
          But each season, the mirror told me a quieter, harder story.
        </p>

        <p>I felt stuck.</p>
        <p>Truly stuck.</p>

        <p>
          I started to feel invisible — at work, in photos, even at the grocery store. My
          favorite jeans hung in the closet like a gentle accusation. By 3 p.m., my energy was
          gone, and I had nothing left for the people I loved.
        </p>

        <p className="italic text-foreground/75">
          Around that time, nothing I tried seemed to last more than a few days.
        </p>

        <p>
          I tried strict diets. I tried the gym, even when my knees protested. I cut carbs. I
          counted things. I downloaded apps. I bought books. None of it felt like it fit a real
          life — my real life — with work, family, and a body that had simply changed.
        </p>

        <p className="italic text-foreground/75">
          I remember looking in the mirror and not recognizing myself anymore.
        </p>

        <p className="text-foreground/85">Then something shifted.</p>
      </div>

      <blockquote className="mt-10 border-l-2 border-primary/60 pl-6 font-serif text-2xl italic text-foreground sm:text-3xl">
        "What I discovered surprised me… and it wasn't what I expected."
      </blockquote>

      <p className="mt-6 font-serif text-xl italic text-foreground/85">
        What I discovered wasn't harder… it was different.
      </p>

      <div className="mt-10">
        <Signature />
      </div>
    </div>
  </section>
);

export default Story;
